import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Amplify } from 'aws-amplify'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'
import { initPostHog } from './utils/posthog'

initPostHog()

// Configure Amplify - these values should be set via environment variables
const cognitoConfig: any = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_XXXXXXXXX',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || 'xxxxxxxxxxxxxxxxxxxxxxxxxx',
}

// Only add identity pool if it's configured
if (import.meta.env.VITE_IDENTITY_POOL_ID) {
  cognitoConfig.identityPoolId = import.meta.env.VITE_IDENTITY_POOL_ID
}

const amplifyConfig = {
  Auth: {
    Cognito: cognitoConfig
  },
  API: {
    REST: {
      SoftitectAPI: {
        endpoint: import.meta.env.VITE_API_ENDPOINT || 'https://api.softitect.com',
        region: import.meta.env.VITE_AWS_REGION || 'us-east-1'
      }
    }
  }
}

Amplify.configure(amplifyConfig)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#0F1218',
            color: '#E6E8EC',
            border: '1px solid #1A1F2B',
          },
          success: {
            iconTheme: {
              primary: '#10B981',
              secondary: '#0F1218',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#0F1218',
            },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)